import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';
import KlassiBrand from '../../components/KlassiBrand';

const KlassiTechHome = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">KlassiTech</h1>
          <p className="lead text-warning fw-bold">Innovative Solutions for Your Business</p>
        </div>

        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Our Core Values</h2>
              <p className="text-primary mb-4">
                <p>
                  At Klassi, our core values are the foundation of everything we do. They guide our decisions, shape our culture, and define our commitment to excellence. We believe in fostering an environment where innovation thrives, collaboration flourishes, and every team member is empowered to contribute to our shared success. Our values include:
                </p>
                <ul>
                  <li><strong>Innovation:</strong> We embrace change and explore new technologies to stay ahead.</li>
                  <li><strong>Excellence:</strong> We uphold the highest standards in everything we do.</li>
                  <li><strong>Integrity:</strong> We act with honesty, transparency, and accountability.</li>
                  <li><strong>Collaboration:</strong> We believe in the power of teamwork and partnership.</li>
                  <li><strong>Customer-Centricity:</strong> We prioritize our clients’ needs and success.</li>
                  <li><strong>Continuous Growth:</strong> We foster learning and improvement at every level.</li>
                </ul>
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Why Choose <KlassiBrand />Tech</h2>
              <p className="text-primary mb-4">
                <p>
                  Klassi is not just a software development company; we are your strategic partner in innovation. Our team combines deep technical expertise with a passion for delivering tailored solutions that drive real business value. Here’s why you should choose us:
                </p>
                <ul>
                  <li><strong>Tailored Solutions:</strong> Custom-built to align with your unique goals.</li>
                  <li><strong>Deep Technical Expertise:</strong> Skilled in modern technologies and frameworks.</li>
                  <li><strong>Strategic Insight:</strong> We understand business and deliver real value.</li>
                  <li><strong>Agile & Transparent Process:</strong> Clear communication and full visibility.</li>
                  <li><strong>Long-Term Partnership:</strong> Ongoing support for sustainable growth.</li>
                </ul>
              </p>
            </div>
          </Col>
        </Row>

        <div>
          <div>
            <p></p>
            <br></br>
          </div>
            <h2 className="text-light text-center fw-bold mb-4">Explore Our Solutions</h2>
            <p className="text-primary mb-4">
              Discover how KlassiTech can transform your business with our innovative solutions. From automation and AI integration to custom software development, we have the expertise to help you succeed in the digital age.
            </p>
        </div>

        <Row className="g-4 mb-5 justify-content-center">
          <Col xs={12} sm={6} md={4} lg={3} className="text-center">
            <Link to="/klassitech/automation" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/automation-solution.png"
                  alt="Automation Solutions"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Automation Solutions</h3>
              <p className="text-light-50">
                Streamline your operations with intelligent automation.
                From test automation to process optimization.
              </p>
            </Link>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="text-center">
            <Link to="/klassitech/ai" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/aiIntegration.png"
                  alt="AI Integration"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">AI Integration</h3>
              <p className="text-light-50">
                Harness the power of artificial intelligence.
                Machine learning, NLP, and computer vision solutions.
              </p>
            </Link>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="text-center">
            <Link to="/klassitech/development" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/software-development.png"
                  alt="Software Development"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Software Development</h3>
              <p className="text-light-50">
                Custom software solutions for your business.
                Web, mobile, and enterprise applications.
              </p>
            </Link>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="text-center">
            <Link to="/klassitech/Framework" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png"
                  alt="Automation Framework"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Automation Framework</h3>
              <p className="text-light-50">
                Discover our robust, intelligent test automation framework powered by Klassi-JS.
                BDD, cross-platform, AI-enhanced, and CI/CD ready.
              </p>
            </Link>
          </Col>
        </Row>

        <div className="video-container bg-dark p-4 rounded shadow-lg mb-5">
          <h3 className="mt-3 text-light text-center fw-bold">Test Automation Talks</h3>
        <p></p>
          <div className="ratio ratio-16x9" style={{ maxWidth: '100vh', margin: '0 auto' }}>
            <iframe
              src="https://www.youtube.com/embed/brSA9Ltsqe4?rel=0"
              title="KlassiTech Overview"
              allowFullScreen
              style={{ borderRadius: '10px' }}
            />
          </div>
        </div>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default KlassiTechHome; 